export const LotsManagementCrumbs = [
  {
    name: 'Home',
    path: '/',
  },
  {
    name: 'Sportello',
    path: '/sportello',
  },
  {
    name: "Gestione lotti carte d'identità",
    path: '/sportello/gestione-lotti',
  },
];

export const LotsManagementNewCrumbs = LotsManagementCrumbs.concat([
  {
    name: "Nuovo lotto carte d'identità",
    path: '/sportello/gestione-lotti/nuovo',
  },
]);

export const LotsManagementEditCrumbs = LotsManagementCrumbs.concat([
  {
    name: "Modifica lotto carte d'identità",
    path: '/sportello/gestione-lotti/modifica',
  },
]);

export const LotsManagementDetailCrumbs = LotsManagementCrumbs.concat([
  {
    name: "Dettaglio lotto carte d'identità",
    path: '/sportello/gestione-lotti/dettaglio',
  },
]);
